import { HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

export const LoadingDots = ({ className }: HTMLAttributes<HTMLDivElement>) => (
  <div className={twMerge('inline-flex items-center justify-center rounded-xl', className)}>
    <div className="inline-flex items-start justify-center gap-1">
      <div className="flex grow basis-0 flex-col items-center justify-center self-stretch px-px">
        <div className="animate-grow h-1.5 w-1.5 rounded-full bg-violet-950" />
      </div>
      <div className="flex grow basis-0 flex-col items-center justify-center self-stretch px-px">
        <div className="animate-grow2 h-1.5 w-1.5 rounded-full bg-violet-950" />
      </div>
      <div className="flex grow basis-0 flex-col items-center justify-center self-stretch px-px">
        <div className="animate-grow3 h-1.5 w-1.5 rounded-full bg-violet-950" />
      </div>
    </div>
    <span className="sr-only">Loading</span>
  </div>
);
